var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_90_14841)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.4,
    cy: 13,
    r: 11.75,
    fill: "white",
    stroke: "#F3F3F4",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.117 16.7754C17.2231 16.7106 17.3952 16.7106 17.5013 16.7754L21.9204 19.4712C22.0266 19.536 22.0266 19.641 21.9204 19.7057L16.5999 22.9514C16.4938 23.0162 16.3218 23.0162 16.2156 22.9514L11.7965 20.2556C11.6904 20.1908 11.6904 20.0859 11.7965 20.0211L17.117 16.7754Z",
    fill: "url(#paint0_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4848 15.0472C14.5909 14.9824 14.7631 14.9824 14.8692 15.0472L19.9343 18.1371L20.3455 17.8862V18.4294C20.3609 18.4812 20.3359 18.5366 20.2703 18.5766L14.8692 21.8715C14.7631 21.9363 14.5909 21.9363 14.4848 21.8715L9.08373 18.5766C9.0321 18.5451 9.00558 18.5041 9.00416 18.4628L9.00403 18.4627V17.8714L9.42959 18.1311L14.4848 15.0472Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4828 14.4607C14.5889 14.3959 14.761 14.3959 14.8671 14.4607L20.2704 17.7569C20.3765 17.8216 20.3765 17.9266 20.2704 17.9913L14.8671 21.2875C14.761 21.3523 14.5889 21.3523 14.4828 21.2875L9.0796 17.9913C8.97347 17.9266 8.97347 17.8216 9.0796 17.7569L14.4828 14.4607Z",
    fill: "#DEEFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0873 18.3147C17.1937 18.2504 17.3662 18.2504 17.4726 18.3147L18.3884 18.8681C18.4948 18.9324 18.4948 19.0366 18.3884 19.1009L16.0758 20.4983C15.9694 20.5626 15.797 20.5626 15.6906 20.4983L14.7747 19.9449C14.6684 19.8806 14.6684 19.7764 14.7747 19.7121L17.0873 18.3147Z",
    fill: "url(#paint1_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9415 11.4216H10.9223V17.5059C10.9136 17.5542 10.9396 17.6045 11.0002 17.6415L13.0048 18.8675L15.1433 20.1753C15.1754 20.1949 15.2275 20.1949 15.2596 20.1753L17.7565 18.6483C17.8211 18.6088 17.8464 18.5543 17.8322 18.5031V12.4265H15.9415V11.4216Z",
    fill: "url(#paint2_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3608 9.85114C13.4667 9.78611 13.6386 9.78611 13.7445 9.85114L17.754 12.3123C17.86 12.3773 17.86 12.4828 17.754 12.5478L15.391 13.9983C15.2849 14.0634 15.1129 14.0633 15.007 13.9981L14.9372 13.9551L14.3934 13.6257L13.0022 12.7679L11.9039 12.0938L11.618 11.9186L11.0835 11.5882L10.9997 11.5373C10.8926 11.4724 10.8921 11.3665 10.9985 11.3011L13.3608 9.85114Z",
    fill: "url(#paint3_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5344 13.7331L15.5602 14.3162L15.5602 14.7324L16.5344 14.1493L16.5344 13.7331Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4873 13.761L15.5599 14.3161L15.5599 14.6607L16.4873 14.1056L16.4873 13.761Z",
    fill: "url(#paint4_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5344 14.2837L15.5602 14.8669L15.5602 15.2831L16.5344 14.6999L16.5344 14.2837Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4873 14.3117L15.5599 14.8668L15.5599 15.2114L16.4873 14.6563L16.4873 14.3117Z",
    fill: "url(#paint5_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5344 14.8194L15.5602 15.4025L15.5602 15.8187L16.5344 15.2356L16.5344 14.8194Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4876 14.8473L15.5602 15.4023L15.5602 15.7469L16.4876 15.1918L16.4876 14.8473Z",
    fill: "url(#paint6_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5344 15.3594L15.5602 15.9426L15.5602 16.3588L16.5344 15.7756L16.5344 15.3594Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4873 15.3873L15.5599 15.9424L15.5599 16.2869L16.4873 15.7319L16.4873 15.3873Z",
    fill: "url(#paint7_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5344 15.9134L15.5602 16.4966L15.5602 16.9128L16.5344 16.3296L16.5344 15.9134Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4873 15.9413L15.5599 16.4964L15.5599 16.841L16.4873 16.2859L16.4873 15.9413Z",
    fill: "url(#paint8_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5344 16.4416L15.5602 17.0247L15.5602 17.4409L16.5344 16.8578L16.5344 16.4416Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4873 16.4695L15.5599 17.0246L15.5599 17.3692L16.4873 16.8141L16.4873 16.4695Z",
    fill: "url(#paint9_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5344 16.9696L15.5602 17.5527L15.5602 17.9689L16.5344 17.3858L16.5344 16.9696Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4873 16.9976L15.5599 17.5527L15.5599 17.8972L16.4873 17.3422L16.4873 16.9976Z",
    fill: "url(#paint10_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5344 17.498L15.5602 18.0812L15.5602 18.4974L16.5344 17.9142L16.5344 17.498Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4873 17.5259L15.5599 18.081L15.5599 18.4255L16.4873 17.8705L16.4873 17.5259Z",
    fill: "url(#paint11_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5344 18.0262L15.5602 18.6093L15.5602 19.0255L16.5344 18.4424L16.5344 18.0262Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4873 18.0541L15.5599 18.6092L15.5599 18.9537L16.4873 18.3987L16.4873 18.0541Z",
    fill: "url(#paint12_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5984 13.0747L16.6241 13.6578L16.6241 14.074L17.5984 13.4909L17.5984 13.0747Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5514 13.1027L16.624 13.6578L16.624 14.0023L17.5514 13.4473L17.5514 13.1027Z",
    fill: "url(#paint13_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5984 13.6256L16.6241 14.2087L16.6241 14.6249L17.5984 14.0418L17.5984 13.6256Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5514 13.6535L16.624 14.2086L16.624 14.5531L17.5514 13.998L17.5514 13.6535Z",
    fill: "url(#paint14_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5984 14.1611L16.6241 14.7443L16.6241 15.1605L17.5984 14.5773L17.5984 14.1611Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5515 14.189L16.6241 14.7441L16.6241 15.0886L17.5515 14.5336L17.5515 14.189Z",
    fill: "url(#paint15_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5984 14.701L16.6241 15.2841L16.6241 15.7003L17.5984 15.1172L17.5984 14.701Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5514 14.729L16.624 15.2841L16.624 15.6287L17.5514 15.0736L17.5514 14.729Z",
    fill: "url(#paint16_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5984 15.2551L16.6241 15.8383L16.6241 16.2544L17.5984 15.6713L17.5984 15.2551Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5514 15.283L16.624 15.8381L16.624 16.1826L17.5514 15.6276L17.5514 15.283Z",
    fill: "url(#paint17_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5984 15.7833L16.6241 16.3665L16.6241 16.7826L17.5984 16.1995L17.5984 15.7833Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5514 15.8112L16.624 16.3663L16.624 16.7108L17.5514 16.1558L17.5514 15.8112Z",
    fill: "url(#paint18_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5984 16.3114L16.6241 16.8946L16.6241 17.3108L17.5984 16.7276L17.5984 16.3114Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5514 16.3395L16.624 16.8945L16.624 17.2391L17.5514 16.684L17.5514 16.3395Z",
    fill: "url(#paint19_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5984 16.8398L16.6241 17.4229L16.6241 17.8391L17.5984 17.256L17.5984 16.8398Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5514 16.8678L16.624 17.4229L16.624 17.7674L17.5514 17.2123L17.5514 16.8678Z",
    fill: "url(#paint20_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5984 17.3678L16.6241 17.951L16.6241 18.3672L17.5984 17.784L17.5984 17.3678Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5514 17.3958L16.624 17.9509L16.624 18.2954L17.5514 17.7403L17.5514 17.3958Z",
    fill: "url(#paint21_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.934 13.1178L11.0996 12.0198L11.0996 12.436L12.934 13.534L12.934 13.1178Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9339 13.1178L11.1465 12.0479L11.1465 12.3899L12.9339 13.4598L12.9339 13.1178Z",
    fill: "url(#paint22_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.934 13.6218L11.0996 12.5238L11.0996 12.94L12.934 14.038L12.934 13.6218Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9339 13.6218L11.1465 12.5519L11.1465 12.8939L12.9339 13.9638L12.9339 13.6218Z",
    fill: "url(#paint23_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.934 14.1323L11.0996 13.0343L11.0996 13.4505L12.934 14.5485L12.934 14.1323Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9339 14.1323L11.1465 13.0624L11.1465 13.4045L12.9339 14.4743L12.9339 14.1323Z",
    fill: "url(#paint24_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.934 14.632L11.0996 13.5341L11.0996 13.9502L12.934 15.0482L12.934 14.632Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9339 14.632L11.1465 13.5621L11.1465 13.9042L12.9339 14.974L12.9339 14.632Z",
    fill: "url(#paint25_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.934 15.1317L11.0996 14.0338L11.0996 14.4499L12.934 15.5479L12.934 15.1317Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9339 15.1318L11.1465 14.062L11.1465 14.404L12.9339 15.4738L12.9339 15.1318Z",
    fill: "url(#paint26_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.934 15.6316L11.0996 14.5336L11.0996 14.9498L12.934 16.0477L12.934 15.6316Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9339 15.6316L11.1465 14.5618L11.1465 14.9038L12.9339 15.9737L12.9339 15.6316Z",
    fill: "url(#paint27_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.934 16.1314L11.0996 15.0334L11.0996 15.4496L12.934 16.5476L12.934 16.1314Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9339 16.1314L11.1465 15.0615L11.1465 15.4035L12.9339 16.4734L12.9339 16.1314Z",
    fill: "url(#paint28_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.934 16.6311L11.0996 15.5331L11.0996 15.9493L12.934 17.0473L12.934 16.6311Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9339 16.6313L11.1465 15.5614L11.1465 15.9034L12.9339 16.9733L12.9339 16.6313Z",
    fill: "url(#paint29_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.934 17.1308L11.0996 16.0328L11.0996 16.449L12.934 17.547L12.934 17.1308Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9339 17.131L11.1465 16.0611L11.1465 16.4031L12.9339 17.473L12.9339 17.131Z",
    fill: "url(#paint30_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5314 18.0342L12.2567 17.2712L12.2567 18.4151L13.5314 19.178L13.5314 18.0342Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4773 18.0595L12.3064 17.3586L12.3064 18.4432L13.4773 19.144L13.4773 18.0595Z",
    fill: "url(#paint31_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9001 14.3304L13.0657 13.2324L13.0657 13.6486L14.9001 14.7465L14.9001 14.3304Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8998 14.3303L13.1123 13.2604L13.1123 13.6024L14.8998 14.6723L14.8998 14.3303Z",
    fill: "url(#paint32_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9001 14.8341L13.0657 13.7361L13.0657 14.1523L14.9001 15.2503L14.9001 14.8341Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8998 14.8342L13.1123 13.7643L13.1123 14.1064L14.8998 15.1762L14.8998 14.8342Z",
    fill: "url(#paint33_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9001 15.3447L13.0657 14.2467L13.0657 14.6629L14.9001 15.7609L14.9001 15.3447Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8998 15.3447L13.1123 14.2748L13.1123 14.6168L14.8998 15.6867L14.8998 15.3447Z",
    fill: "url(#paint34_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9001 15.8445L13.0657 14.7465L13.0657 15.1627L14.9001 16.2607L14.9001 15.8445Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8998 15.8445L13.1123 14.7747L13.1123 15.1167L14.8998 16.1866L14.8998 15.8445Z",
    fill: "url(#paint35_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9001 16.3443L13.0657 15.2463L13.0657 15.6625L14.9001 16.7605L14.9001 16.3443Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8998 16.3442L13.1123 15.2743L13.1123 15.6163L14.8998 16.6862L14.8998 16.3442Z",
    fill: "url(#paint36_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9001 16.844L13.0657 15.746L13.0657 16.1622L14.9001 17.2602L14.9001 16.844Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8998 16.8441L13.1123 15.7742L13.1123 16.1162L14.8998 17.1861L14.8998 16.8441Z",
    fill: "url(#paint37_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9001 17.3438L13.0657 16.2458L13.0657 16.662L14.9001 17.76L14.9001 17.3438Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8998 17.3438L13.1123 16.2739L13.1123 16.6159L14.8998 17.6858L14.8998 17.3438Z",
    fill: "url(#paint38_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9001 17.8435L13.0657 16.7455L13.0657 17.1617L14.9001 18.2597L14.9001 17.8435Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8998 17.8436L13.1123 16.7737L13.1123 17.1158L14.8998 18.1856L14.8998 17.8436Z",
    fill: "url(#paint39_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9001 18.3434L13.0657 17.2454L13.0657 17.6616L14.9001 18.7595L14.9001 18.3434Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8998 18.3433L13.1123 17.2734L13.1123 17.6155L14.8998 18.6853L14.8998 18.3433Z",
    fill: "url(#paint40_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4471 9.69171C13.5503 9.64504 13.6929 9.64896 13.7888 9.70108L18.4513 12.2329C18.5095 12.2645 18.5427 12.3099 18.5425 12.3575L18.5411 12.7017C18.5409 12.7456 18.5122 12.7878 18.4613 12.8189L15.6408 14.5386C15.5333 14.6041 15.359 14.6031 15.2536 14.5363L15.135 14.4612L14.5136 14.0863L12.9241 13.1098L11.6691 12.3423L11.3425 12.1428L10.7318 11.7668L10.4952 11.6238C10.4434 11.5925 10.4143 11.5497 10.4146 11.5051L10.4166 11.1442C10.4169 11.0917 10.4577 11.0424 10.5268 11.0112L13.4471 9.69171Z",
    fill: "url(#paint41_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3151 9.28689C13.4212 9.222 13.5932 9.222 13.6993 9.28689L18.4519 12.1934C18.558 12.2583 18.558 12.3635 18.4519 12.4283L15.6195 14.1605C15.5133 14.2254 15.3411 14.2253 15.235 14.1603L15.1212 14.0904L14.4853 13.7067L12.8587 12.7074L11.5745 11.9221L11.2403 11.718L10.6153 11.3332L10.4846 11.2542C10.3775 11.1894 10.377 11.0837 10.4835 11.0186L13.3151 9.28689Z",
    fill: "url(#paint42_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7508 10.0703C13.8569 10.0054 14.0289 10.0054 14.1349 10.0703L17.9931 12.4298C18.0992 12.4946 18.0992 12.5998 17.9931 12.6647L16.0214 13.8705C15.9152 13.9355 15.743 13.9354 15.637 13.8703L15.5763 13.8331L15.0516 13.516L13.7079 12.691L12.6473 12.0423L12.3713 11.8738L11.855 11.5561L11.7807 11.5112C11.6737 11.4464 11.6733 11.3408 11.7797 11.2757L13.7508 10.0703Z",
    fill: "url(#paint43_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.846 5.85541H11.44V11.2033C11.4232 11.256 11.4484 11.3128 11.5156 11.3534L11.5662 11.384L12.0372 11.6739L12.289 11.8277L13.2567 12.4195L14.4824 13.1725L14.9615 13.4616L15 13.4853C15.106 13.5503 15.2783 13.5504 15.3845 13.4855L17.4204 12.2404C17.4866 12.1999 17.5115 12.1437 17.495 12.0913V6.74072H15.846V5.85541Z",
    fill: "url(#paint44_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5497 4.48585C13.6556 4.42081 13.8274 4.42081 13.9334 4.48585L17.4204 6.62626C17.5264 6.6913 17.5264 6.79674 17.4204 6.86178L15.3842 8.11168C15.278 8.17682 15.106 8.17671 15.0001 8.11147L14.9614 8.08765L14.4823 7.79747L13.2565 7.04171L12.2889 6.44772L12.037 6.29334L11.5661 6.00233L11.5153 5.9715C11.4083 5.90657 11.4078 5.8006 11.5142 5.73529L13.5497 4.48585Z",
    fill: "url(#paint45_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3684 7.89191L15.51 8.4057L15.51 8.77239L16.3684 8.2586L16.3684 7.89191Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3271 7.91658L15.51 8.40564L15.51 8.70921L16.3271 8.22016L16.3271 7.91658Z",
    fill: "url(#paint46_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3684 8.3772L15.51 8.89099L15.51 9.25768L16.3684 8.74389L16.3684 8.3772Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3271 8.40187L15.51 8.89093L15.51 9.19451L16.3271 8.70545L16.3271 8.40187Z",
    fill: "url(#paint47_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3684 8.84901L15.51 9.36279L15.51 9.72948L16.3684 9.2157L16.3684 8.84901Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3271 8.87367L15.51 9.36273L15.51 9.66631L16.3271 9.17725L16.3271 8.87367Z",
    fill: "url(#paint48_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3684 9.32471L15.51 9.8385L15.51 10.2052L16.3684 9.6914L16.3684 9.32471Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3271 9.34944L15.51 9.8385L15.51 10.1421L16.3271 9.65302L16.3271 9.34944Z",
    fill: "url(#paint49_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3684 9.81299L15.51 10.3268L15.51 10.6935L16.3684 10.1797L16.3684 9.81299Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3271 9.83754L15.51 10.3266L15.51 10.6302L16.3271 10.1411L16.3271 9.83754Z",
    fill: "url(#paint50_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3684 10.2784L15.51 10.7922L15.51 11.1589L16.3684 10.6451L16.3684 10.2784Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3271 10.3031L15.51 10.7922L15.51 11.0958L16.3271 10.6067L16.3271 10.3031Z",
    fill: "url(#paint51_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3684 10.7436L15.51 11.2574L15.51 11.6241L16.3684 11.1103L16.3684 10.7436Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3271 10.7683L15.51 11.2574L15.51 11.561L16.3271 11.0719L16.3271 10.7683Z",
    fill: "url(#paint52_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3684 11.2091L15.51 11.7228L15.51 12.0895L16.3684 11.5757L16.3684 11.2091Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3271 11.2337L15.51 11.7228L15.51 12.0264L16.3271 11.5373L16.3271 11.2337Z",
    fill: "url(#paint53_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3684 11.6744L15.51 12.1882L15.51 12.5549L16.3684 12.0411L16.3684 11.6744Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3271 11.6991L15.51 12.1881L15.51 12.4917L16.3271 12.0026L16.3271 11.6991Z",
    fill: "url(#paint54_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3059 7.31196L16.4475 7.82574L16.4475 8.19243L17.3059 7.67865L17.3059 7.31196Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2645 7.33669L16.4474 7.82574L16.4474 8.12932L17.2645 7.64026L17.2645 7.33669Z",
    fill: "url(#paint55_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3059 7.79725L16.4475 8.31104L16.4475 8.67772L17.3059 8.16394L17.3059 7.79725Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2645 7.82179L16.4474 8.31085L16.4474 8.61443L17.2645 8.12537L17.2645 7.82179Z",
    fill: "url(#paint56_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3059 8.26899L16.4475 8.78278L16.4475 9.14947L17.3059 8.63568L17.3059 8.26899Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2646 8.29372L16.4475 8.78278L16.4475 9.08635L17.2646 8.59729L17.2646 8.29372Z",
    fill: "url(#paint57_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3059 8.7447L16.4475 9.25848L16.4475 9.62517L17.3059 9.11139L17.3059 8.7447Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2645 8.7693L16.4474 9.25836L16.4474 9.56194L17.2645 9.07288L17.2645 8.7693Z",
    fill: "url(#paint58_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3059 9.23304L16.4475 9.74683L16.4475 10.1135L17.3059 9.59973L17.3059 9.23304Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2645 9.25765L16.4474 9.7467L16.4474 10.0503L17.2645 9.56122L17.2645 9.25765Z",
    fill: "url(#paint59_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3059 9.69831L16.4475 10.2121L16.4475 10.5788L17.3059 10.065L17.3059 9.69831Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2645 9.72298L16.4474 10.212L16.4474 10.5156L17.2645 10.0266L17.2645 9.72298Z",
    fill: "url(#paint60_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3059 10.1637L16.4475 10.6775L16.4475 11.0442L17.3059 10.5304L17.3059 10.1637Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2645 10.1884L16.4474 10.6774L16.4474 10.981L17.2645 10.4919L17.2645 10.1884Z",
    fill: "url(#paint61_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3059 10.629L16.4475 11.1428L16.4475 11.5095L17.3059 10.9957L17.3059 10.629Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2645 10.6536L16.4474 11.1426L16.4474 11.4462L17.2645 10.9572L17.2645 10.6536Z",
    fill: "url(#paint62_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3059 11.0944L16.4475 11.6082L16.4475 11.9749L17.3059 11.4611L17.3059 11.0944Z",
    fill: "#648FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2645 11.1191L16.4474 11.6082L16.4474 11.9117L17.2645 11.4227L17.2645 11.1191Z",
    fill: "url(#paint63_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1963 7.34984L11.5801 6.38245L11.5801 6.74914L13.1963 7.71653L13.1963 7.34984Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1964 7.34998L11.6216 6.40735L11.6216 6.70869L13.1964 7.65132L13.1964 7.34998Z",
    fill: "url(#paint64_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1963 7.79394L11.5801 6.82654L11.5801 7.19323L13.1963 8.16063L13.1963 7.79394Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1964 7.79377L11.6216 6.85114L11.6216 7.15247L13.1964 8.0951L13.1964 7.79377Z",
    fill: "url(#paint65_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1963 8.2437L11.5801 7.27631L11.5801 7.643L13.1963 8.61039L13.1963 8.2437Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1964 8.2436L11.6216 7.30096L11.6216 7.6023L13.1964 8.54493L13.1964 8.2436Z",
    fill: "url(#paint66_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1963 8.68395L11.5801 7.71655L11.5801 8.08324L13.1963 9.05064L13.1963 8.68395Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1964 8.68396L11.6216 7.74133L11.6216 8.04267L13.1964 8.9853L13.1964 8.68396Z",
    fill: "url(#paint67_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1963 9.12438L11.5801 8.15698L11.5801 8.52367L13.1963 9.49107L13.1963 9.12438Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1964 9.12439L11.6216 8.18176L11.6216 8.4831L13.1964 9.42573L13.1964 9.12439Z",
    fill: "url(#paint68_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1963 9.56469L11.5801 8.59729L11.5801 8.96398L13.1963 9.93138L13.1963 9.56469Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1964 9.56464L11.6216 8.62201L11.6216 8.92335L13.1964 9.86598L13.1964 9.56464Z",
    fill: "url(#paint69_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1963 10.0051L11.5801 9.03766L11.5801 9.40435L13.1963 10.3717L13.1963 10.0051Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1964 10.0049L11.6216 9.06232L11.6216 9.36365L13.1964 10.3063L13.1964 10.0049Z",
    fill: "url(#paint70_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1963 10.4454L11.5801 9.47797L11.5801 9.84466L13.1963 10.8121L13.1963 10.4454Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1964 10.4453L11.6216 9.50269L11.6216 9.80402L13.1964 10.7467L13.1964 10.4453Z",
    fill: "url(#paint71_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1963 10.8857L11.5801 9.91833L11.5801 10.285L13.1963 11.2524L13.1963 10.8857Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1964 10.8857L11.6216 9.94312L11.6216 10.2445L13.1964 11.1871L13.1964 10.8857Z",
    fill: "url(#paint72_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 8.41814L13.3121 7.45074L13.3121 7.81743L14.9284 8.78483L14.9284 8.41814Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 8.41809L13.3535 7.47546L13.3535 7.7768L14.9284 8.71943L14.9284 8.41809Z",
    fill: "url(#paint73_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 8.86211L13.3121 7.89471L13.3121 8.2614L14.9284 9.2288L14.9284 8.86211Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 8.86213L13.3535 7.91949L13.3535 8.22083L14.9284 9.16346L14.9284 8.86213Z",
    fill: "url(#paint74_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 9.31188L13.3121 8.34448L13.3121 8.71117L14.9284 9.67857L14.9284 9.31188Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 9.31189L13.3535 8.36926L13.3535 8.6706L14.9284 9.61323L14.9284 9.31189Z",
    fill: "url(#paint75_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 9.75219L13.3121 8.78479L13.3121 9.15148L14.9284 10.1189L14.9284 9.75219Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 9.75232L13.3535 8.80969L13.3535 9.11103L14.9284 10.0537L14.9284 9.75232Z",
    fill: "url(#paint76_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 10.1926L13.3121 9.22522L13.3121 9.59191L14.9284 10.5593L14.9284 10.1926Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 10.1926L13.3535 9.24994L13.3535 9.55128L14.9284 10.4939L14.9284 10.1926Z",
    fill: "url(#paint77_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 10.633L13.3121 9.66559L13.3121 10.0323L14.9284 10.9997L14.9284 10.633Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 10.6329L13.3535 9.69031L13.3535 9.99165L14.9284 10.9343L14.9284 10.6329Z",
    fill: "url(#paint78_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 11.0733L13.3121 10.1059L13.3121 10.4726L14.9284 11.44L14.9284 11.0733Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 11.0732L13.3535 10.1306L13.3535 10.4319L14.9284 11.3745L14.9284 11.0732Z",
    fill: "url(#paint79_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 11.5137L13.3121 10.5463L13.3121 10.913L14.9284 11.8804L14.9284 11.5137Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 11.5136L13.3535 10.571L13.3535 10.8723L14.9284 11.815L14.9284 11.5136Z",
    fill: "url(#paint80_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 11.954L13.3121 10.9866L13.3121 11.3533L14.9284 12.3207L14.9284 11.954Z",
    fill: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 11.9539L13.3535 11.0112L13.3535 11.3126L14.9284 12.2552L14.9284 11.9539Z",
    fill: "url(#paint81_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5353 10.2269L15.5599 13.3213V14.1854L15.4196 14.2787L13.0476 12.6635L11.7915 11.8899L11.4648 11.6888L10.8514 11.3105L10.5353 11.1163L10.4025 10.3097L10.5353 10.2269Z",
    fill: "#13454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4023 10.3101L15.419 13.3996V14.2791L12.9107 12.7601L11.6565 11.9877L11.3303 11.7869L10.7179 11.4091L10.4023 11.2153V10.3101Z",
    fill: "url(#paint82_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6537 4.37347C13.7568 4.32671 13.8991 4.33063 13.995 4.38289L17.754 6.43165C17.8121 6.46335 17.8453 6.50885 17.8451 6.55659L17.8441 6.8122C17.8439 6.85632 17.8152 6.89859 17.7644 6.92973L15.5123 8.30792C15.405 8.37362 15.2308 8.37261 15.1255 8.30565L15.0638 8.2664L14.5565 7.95925L13.2591 7.15917L12.2347 6.53039L11.9681 6.36696L11.4696 6.05888L11.2913 5.95074C11.2395 5.91931 11.2104 5.87642 11.2107 5.8317L11.2122 5.56413C11.2125 5.51149 11.2533 5.46203 11.3223 5.43075L13.6537 4.37347Z",
    fill: "url(#paint83_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.55 4.04878C13.6559 3.98374 13.8277 3.98374 13.9337 4.04878L17.7429 6.38697C17.8489 6.45201 17.8489 6.55747 17.7429 6.6225L15.5012 7.99855C15.3951 8.06365 15.223 8.06358 15.1171 7.99834L15.0593 7.96269L14.5403 7.64833L13.2125 6.82966L12.1642 6.18623L11.8914 6.019L11.3813 5.70376L11.3101 5.66056C11.2031 5.59563 11.2026 5.48966 11.309 5.42435L13.55 4.04878Z",
    fill: "#FA9960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.558 4.24617C13.664 4.18113 13.8357 4.18113 13.9417 4.24617L17.4069 6.37319C17.5129 6.43823 17.5129 6.54368 17.4069 6.60872L15.502 7.77797C15.3959 7.84311 15.2239 7.843 15.118 7.77776L15.0806 7.75474L14.6043 7.4661L13.3854 6.71468L12.4231 6.12405L12.1727 5.97052L11.7043 5.68121L11.6549 5.65117C11.5479 5.58624 11.5474 5.48029 11.6538 5.41499L13.558 4.24617Z",
    fill: "#FFB387"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9417 4.24617C13.8357 4.18113 13.664 4.18113 13.558 4.24617L11.6538 5.41499C11.5475 5.48027 11.5479 5.58619 11.6548 5.65113C11.6552 5.65087 11.6557 5.65061 11.6561 5.65034L13.5603 4.48152C13.6662 4.41648 13.838 4.41648 13.944 4.48152L17.4082 6.60793C17.5129 6.54283 17.5125 6.43797 17.4069 6.37319L13.9417 4.24617Z",
    fill: "#DA6420"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7364 4.64178L15.6661 5.82626L14.5083 6.53694L14.3934 6.46615L14.1546 6.32144L13.5435 5.9447L13.061 5.64858L12.9355 5.57161L12.7007 5.42656L12.5786 5.35246L13.7364 4.64178Z",
    fill: "#F1935C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2793 4.98572H12.5786V5.35243H13.2793V4.98572Z",
    fill: "#F1935C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6663 5.47858H14.9421V5.82624H15.6663V5.47858Z",
    fill: "#F1935C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7209 4.28467L15.666 5.47862L14.5234 6.18002L14.4075 6.10866L14.1668 5.96278L13.5508 5.58304L13.0645 5.28456L12.938 5.20697L12.7013 5.06077L12.5782 4.98607L13.7209 4.28467Z",
    fill: "#F7BE9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9579 5.95563L16.9544 6.56732L16.0555 7.11911L15.9962 7.08251L15.8725 7.00803L15.5572 6.81326L15.3081 6.66034L15.2432 6.62061L15.1222 6.54557L15.059 6.50741L15.9579 5.95563Z",
    fill: "#F1935C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4158 6.31818H15.0588V6.50736H15.4158V6.31818Z",
    fill: "#F1935C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9543 6.38696H16.5242V6.56725H16.9543V6.38696Z",
    fill: "#F1935C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9506 5.77087L16.9544 6.38704L16.0628 6.93432L16.0031 6.89746L15.8785 6.82242L15.5609 6.62624L15.3099 6.4722L15.2446 6.43217L15.1226 6.35659L15.059 6.31815L15.9506 5.77087Z",
    fill: "#FF9C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9961 6.02203L16.6695 6.43543L16.062 6.80833L16.022 6.7836L15.9383 6.73326L15.7253 6.60164L15.5569 6.49829L15.5131 6.47143L15.4313 6.42073L15.3885 6.39494L15.9961 6.02203Z",
    fill: "#F1935C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6298 6.26703H15.3885V6.39488H15.6298V6.26703Z",
    fill: "#F1935C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6696 6.31342H16.3789V6.43526H16.6696V6.31342Z",
    fill: "#F1935C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9911 5.89703L16.6695 6.31345L16.0669 6.68331L16.0266 6.6584L15.9424 6.60768L15.7277 6.4751L15.5581 6.37099L15.514 6.34395L15.4316 6.29287L15.3885 6.26689L15.9911 5.89703Z",
    fill: "#F7BE9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0562 19.5059L12.666 18.6738L12.1202 19.0005L13.5104 19.8327L14.0562 19.5059Z",
    fill: "url(#paint84_linear_90_14841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1848 18.388L13.575 19.1295L13.5752 19.2202L13.0308 19.5461L11.6404 18.7139L11.6392 18.624L12.1848 18.388Z",
    fill: "#F1935C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5748 19.1294L12.1846 18.2973L11.6387 18.624L13.0289 19.4561L13.5748 19.1294Z",
    fill: "#FFA977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9086 17.723V18.7298",
    stroke: "#34656D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_90_14841",
    x: 0.400024,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_90_14841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_90_14841",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_90_14841",
    x1: 16.8941,
    y1: 17.4997,
    x2: 20.0334,
    y2: 22.5609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.319031,
    stopColor: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70563,
    stopColor: "#B2D7FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_90_14841",
    x1: 16.9275,
    y1: 18.8014,
    x2: 17.6509,
    y2: 19.9563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0809064,
    stopColor: "#7BA6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546153,
    stopColor: "#B2D7FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_90_14841",
    x1: 17.8312,
    y1: 16.7708,
    x2: 12.6371,
    y2: 16.7438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.482154,
    stopColor: "#7FAAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.530993,
    stopColor: "#CFE0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_90_14841",
    x1: 17.0081,
    y1: 12.9454,
    x2: 11.5397,
    y2: 14.2886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_90_14841",
    x1: 16.0236,
    y1: 14.0386,
    x2: 16.1755,
    y2: 14.2922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_90_14841",
    x1: 16.0236,
    y1: 14.5893,
    x2: 16.1755,
    y2: 14.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#34656D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_90_14841",
    x1: 16.0239,
    y1: 15.1248,
    x2: 16.1757,
    y2: 15.3785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_90_14841",
    x1: 16.0236,
    y1: 15.6648,
    x2: 16.1755,
    y2: 15.9185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_90_14841",
    x1: 16.0236,
    y1: 16.2189,
    x2: 16.1755,
    y2: 16.4725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#34656D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_90_14841",
    x1: 16.0236,
    y1: 16.7471,
    x2: 16.1755,
    y2: 17.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#34656D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_90_14841",
    x1: 16.0236,
    y1: 17.2751,
    x2: 16.1755,
    y2: 17.5288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_90_14841",
    x1: 16.0236,
    y1: 17.8035,
    x2: 16.1755,
    y2: 18.0571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_90_14841",
    x1: 16.0236,
    y1: 18.3317,
    x2: 16.1755,
    y2: 18.5853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#34656D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_90_14841",
    x1: 17.0877,
    y1: 13.3802,
    x2: 17.2395,
    y2: 13.6339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#34656D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#316169"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_90_14841",
    x1: 17.0877,
    y1: 13.931,
    x2: 17.2395,
    y2: 14.1847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_90_14841",
    x1: 17.0878,
    y1: 14.4665,
    x2: 17.2397,
    y2: 14.7202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_90_14841",
    x1: 17.0877,
    y1: 15.0066,
    x2: 17.2395,
    y2: 15.2603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#34656D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_90_14841",
    x1: 17.0877,
    y1: 15.5605,
    x2: 17.2395,
    y2: 15.8142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_90_14841",
    x1: 17.0877,
    y1: 16.0887,
    x2: 17.2395,
    y2: 16.3424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_90_14841",
    x1: 17.0877,
    y1: 16.617,
    x2: 17.2395,
    y2: 16.8707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_90_14841",
    x1: 17.0877,
    y1: 17.1453,
    x2: 17.2395,
    y2: 17.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#34656D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_90_14841",
    x1: 17.0877,
    y1: 17.6733,
    x2: 17.2395,
    y2: 17.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_90_14841",
    x1: 12.0402,
    y1: 12.5829,
    x2: 11.8895,
    y2: 12.8347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_90_14841",
    x1: 12.0402,
    y1: 13.0868,
    x2: 11.8895,
    y2: 13.3386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#DA6420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#FFA977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_90_14841",
    x1: 12.0402,
    y1: 13.5974,
    x2: 11.8895,
    y2: 13.8492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_90_14841",
    x1: 12.0402,
    y1: 14.0971,
    x2: 11.8895,
    y2: 14.3489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_90_14841",
    x1: 12.0402,
    y1: 14.5969,
    x2: 11.8895,
    y2: 14.8487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#DA6420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#FFA977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_90_14841",
    x1: 12.0402,
    y1: 15.0967,
    x2: 11.8895,
    y2: 15.3485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_90_14841",
    x1: 12.0402,
    y1: 15.5965,
    x2: 11.8895,
    y2: 15.8483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#DA6420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#FFA977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_90_14841",
    x1: 12.0402,
    y1: 16.0963,
    x2: 11.8895,
    y2: 16.3481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_90_14841",
    x1: 12.0402,
    y1: 16.596,
    x2: 11.8895,
    y2: 16.8478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_90_14841",
    x1: 12.8919,
    y1: 17.2672,
    x2: 12.2192,
    y2: 18.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.261056,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404637,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_90_14841",
    x1: 14.006,
    y1: 13.7953,
    x2: 13.8553,
    y2: 14.0471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_90_14841",
    x1: 14.006,
    y1: 14.2993,
    x2: 13.8553,
    y2: 14.5511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#DA6420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#FFA977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_90_14841",
    x1: 14.006,
    y1: 14.8097,
    x2: 13.8553,
    y2: 15.0615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_90_14841",
    x1: 14.006,
    y1: 15.3096,
    x2: 13.8553,
    y2: 15.5614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_90_14841",
    x1: 14.006,
    y1: 15.8092,
    x2: 13.8553,
    y2: 16.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#DA6420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#FFA977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_90_14841",
    x1: 14.006,
    y1: 16.3091,
    x2: 13.8553,
    y2: 16.5609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#E8854B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26875,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_90_14841",
    x1: 14.006,
    y1: 16.8089,
    x2: 13.8553,
    y2: 17.0607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#DA6420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#FFA977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_90_14841",
    x1: 14.006,
    y1: 17.3087,
    x2: 13.8553,
    y2: 17.5605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_90_14841",
    x1: 14.006,
    y1: 17.8084,
    x2: 13.8553,
    y2: 18.0602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_90_14841",
    x1: 11.5468,
    y1: 11.2939,
    x2: 18.9289,
    y2: 11.2731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.497805,
    stopColor: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528321,
    stopColor: "#5281DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_90_14841",
    x1: 17.2191,
    y1: 13.0765,
    x2: 11.6958,
    y2: 13.4034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8854B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A984"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_90_14841",
    x1: 16.3265,
    y1: 10.9046,
    x2: 17.9022,
    y2: 13.6549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#DA6420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.740131,
    stopColor: "#E8854B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_90_14841",
    x1: 16.4782,
    y1: 12.279,
    x2: 13.3257,
    y2: 12.2385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.355043,
    stopColor: "#80ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434818,
    stopColor: "#CFE0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_90_14841",
    x1: 16.786,
    y1: 7.19807,
    x2: 11.968,
    y2: 8.38151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_90_14841",
    x1: 15.9185,
    y1: 8.16111,
    x2: 16.0523,
    y2: 8.38461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_90_14841",
    x1: 15.9185,
    y1: 8.6464,
    x2: 16.0523,
    y2: 8.8699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#34656D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_90_14841",
    x1: 15.9185,
    y1: 9.1182,
    x2: 16.0523,
    y2: 9.34171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_90_14841",
    x1: 15.9185,
    y1: 9.59397,
    x2: 16.0523,
    y2: 9.81748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_90_14841",
    x1: 15.9185,
    y1: 10.0821,
    x2: 16.0523,
    y2: 10.3056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#34656D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_90_14841",
    x1: 15.9185,
    y1: 10.5476,
    x2: 16.0523,
    y2: 10.7711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#34656D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_90_14841",
    x1: 15.9185,
    y1: 11.0129,
    x2: 16.0523,
    y2: 11.2364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_90_14841",
    x1: 15.9185,
    y1: 11.4783,
    x2: 16.0523,
    y2: 11.7018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_90_14841",
    x1: 15.9185,
    y1: 11.9436,
    x2: 16.0523,
    y2: 12.1671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#34656D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_90_14841",
    x1: 16.8559,
    y1: 7.58122,
    x2: 16.9897,
    y2: 7.80472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#34656D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_90_14841",
    x1: 16.8559,
    y1: 8.06632,
    x2: 16.9897,
    y2: 8.28983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_90_14841",
    x1: 16.856,
    y1: 8.53825,
    x2: 16.9898,
    y2: 8.76175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_90_14841",
    x1: 16.8559,
    y1: 9.01383,
    x2: 16.9897,
    y2: 9.23734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#34656D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_90_14841",
    x1: 16.8559,
    y1: 9.50218,
    x2: 16.9897,
    y2: 9.72568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_90_14841",
    x1: 16.8559,
    y1: 9.96751,
    x2: 16.9897,
    y2: 10.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_90_14841",
    x1: 16.8559,
    y1: 10.4329,
    x2: 16.9897,
    y2: 10.6564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_90_14841",
    x1: 16.8559,
    y1: 10.8981,
    x2: 16.9897,
    y2: 11.1216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#34656D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_90_14841",
    x1: 16.8559,
    y1: 11.3636,
    x2: 16.9897,
    y2: 11.5871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#34656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_90_14841",
    x1: 12.409,
    y1: 6.87866,
    x2: 12.2762,
    y2: 7.10052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_90_14841",
    x1: 12.409,
    y1: 7.32245,
    x2: 12.2762,
    y2: 7.54431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#DA6420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#FFA977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_90_14841",
    x1: 12.409,
    y1: 7.77228,
    x2: 12.2762,
    y2: 7.99413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_90_14841",
    x1: 12.409,
    y1: 8.21265,
    x2: 12.2762,
    y2: 8.4345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_90_14841",
    x1: 12.409,
    y1: 8.65308,
    x2: 12.2762,
    y2: 8.87493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#DA6420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#FFA977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_90_14841",
    x1: 12.409,
    y1: 9.09332,
    x2: 12.2762,
    y2: 9.31518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_90_14841",
    x1: 12.409,
    y1: 9.53363,
    x2: 12.2762,
    y2: 9.75549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#DA6420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#FFA977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_90_14841",
    x1: 12.409,
    y1: 9.974,
    x2: 12.2762,
    y2: 10.1959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_90_14841",
    x1: 12.409,
    y1: 10.4144,
    x2: 12.2762,
    y2: 10.6363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_90_14841",
    x1: 14.1409,
    y1: 7.94678,
    x2: 14.0082,
    y2: 8.16863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_90_14841",
    x1: 14.1409,
    y1: 8.39081,
    x2: 14.0082,
    y2: 8.61266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#DA6420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#FFA977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_90_14841",
    x1: 14.1409,
    y1: 8.84058,
    x2: 14.0082,
    y2: 9.06243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_90_14841",
    x1: 14.1409,
    y1: 9.28101,
    x2: 14.0082,
    y2: 9.50286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_90_14841",
    x1: 14.1409,
    y1: 9.72125,
    x2: 14.0082,
    y2: 9.94311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#DA6420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#FFA977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_90_14841",
    x1: 14.1409,
    y1: 10.1616,
    x2: 14.0082,
    y2: 10.3835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#E8854B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26875,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_90_14841",
    x1: 14.1409,
    y1: 10.6019,
    x2: 14.0082,
    y2: 10.8237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#DA6420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#FFA977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_90_14841",
    x1: 14.1409,
    y1: 11.0423,
    x2: 14.0082,
    y2: 11.2642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_90_14841",
    x1: 14.1409,
    y1: 11.4825,
    x2: 14.0082,
    y2: 11.7044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#28565D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247917,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_90_14841",
    x1: 15.3347,
    y1: 13.7243,
    x2: 14.5877,
    y2: 14.5694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34656D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#509AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_90_14841",
    x1: 12.1348,
    y1: 5.67145,
    x2: 18.1712,
    y2: 5.69051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.499472,
    stopColor: "#A1C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539279,
    stopColor: "#5180DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_90_14841",
    x1: 13.2685,
    y1: 18.9217,
    x2: 13.7268,
    y2: 19.7136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.236684,
    stopColor: "#648FE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886917,
    stopColor: "#DEEFFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/Switch.91eca16006364462c32a64745ffc87ad.svg";
export { ForwardRef as ReactComponent };